var commonStorage = new function() {
    this.getCookie = function(key) {

        var _currentCookie = Cookies.get(key);
        //console.log('Cookies.get 1086: ' + _currentCookie)
        if (_currentCookie !== "undefined") {
            return Cookies.get(key)
        } else {
            return;
        }

    }
    this.setCookie = function(key, value) {
        //console.log('1030: setCookie')
        Cookies.set(key, value);

    }
};

//global function to setitem in localstorage
function localStorageSetItemCommon(key, value) {

    if (key == "_GeoCurrentZipCode") {
        value = zipToString(value);
    }

    commonStorage.setCookie(key, value);
};

//global function to getitem in localstorage
function localStorageGetItemCommon(key) {
    return commonStorage.getCookie(key);
};